import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerIncluded, PRICE, FULL_PRICE, BUNDLE_IMAGE, BRAND } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
import { CountdownPill } from './ui/CountdownPill';
import { Reveal } from './ui/Reveal';
export function Offer() {
  return <section id="offer" className="grain bg-ink px-4 py-14 sm:px-5 sm:py-24" data-id="element-118" data-mp="1hp7j72t2b4w8">
      <div className="mx-auto max-w-3xl" data-id="element-119" data-mp="tzmqhs73wt9r">
        <Reveal data-id="element-120" data-mp="ozrytmfibznn">
          <SectionLabel tone="dark" data-id="element-121" data-mp="p0a3n7g8jm76">Offerta speciale di lancio</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[22ch] text-center text-[1.8rem] text-cream sm:text-[3.3rem]" data-id="element-122" data-mp="p24n0hbuz695">
            Ottieni il Laboratorio del Giovane Inventore{' '}
            <span className="text-sun" data-id="element-123" data-mp="ywmw6201nu0c">oggi a soli {PRICE}</span>
          </h2>
          <div className="mt-5 flex justify-center sm:mt-6" data-id="element-124" data-mp="2fav4osnzc2sz">
            <CountdownPill tone="dark" label="L’offerta termina in" data-id="element-125" data-mp="2admmis2tzyrq" />
          </div>
        </Reveal>

        <Reveal delay={0.05} data-id="element-126" data-mp="pkqm655vjl7n">
          <div className="mt-8 rounded-[1.75rem] bg-white p-5 shadow-lift sm:mt-11 sm:rounded-[2rem] sm:p-10" data-id="element-127" data-mp="pjfkcavzonj6">
            <img src={BUNDLE_IMAGE} alt="La collezione completa: sei volumi e i cinque bonus su monitor, tablet e telefono" className="mx-auto w-full max-w-[420px] rounded-2xl object-contain sm:max-w-[520px]" loading="lazy" width={1656} height={932} data-id="element-128" data-mp="uhqw4r5uh841" />

            <h3 className="display mt-6 text-center text-[1.9rem] leading-[0.95] text-ink sm:mt-8 sm:text-[2.6rem]" data-id="element-129" data-mp="6u9896ppau6c">
              {BRAND}
            </h3>
            <p className="mx-auto mt-3 max-w-[34ch] text-center text-base font-black leading-snug text-ink/55 sm:max-w-none sm:text-xl" data-id="element-130" data-mp="bt2f4gahfmxj">
              6 volumi passo-passo + 5 bonus + progetti, test e sfide di
              ingegneria
            </p>

            <ul className="mt-7 space-y-4 border-t-2 border-ink/10 pt-7 sm:mt-8 sm:pt-8" data-id="element-131" data-mp="3k9fce8iq9gr1">
              {offerIncluded.map(item => <li key={item} className="flex gap-3.5" data-id="element-132" data-mp="3o8win45zahx9">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-orange" strokeWidth={4} aria-hidden="true" data-id="element-133" data-mp="vfh5ia2boxke" />
                  <span className="text-[15px] font-black leading-snug text-ink/70 sm:text-lg" data-id="element-134" data-mp="qh5xm4vl8x4t">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 rounded-[1.5rem] bg-cream px-5 py-7 text-center sm:px-8 sm:py-9" data-id="element-135" data-mp="106pex63nkixk">
              <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-136" data-mp="cgmp6wn7np24">
                <span className="display text-xl text-ink/35 line-through sm:text-2xl" data-id="element-137" data-mp="cipoy8e60wk1">
                  {FULL_PRICE}
                </span>
                <span className="rounded-full bg-orange/12 px-3.5 py-1.5 text-[11px] font-black uppercase tracking-[0.1em] text-orange" data-id="element-138" data-mp="lht6v91lj5wy">
                  Offerta di lancio
                </span>
              </div>

              <p className="display mt-4 text-[3.6rem] leading-none text-orange sm:text-[4.6rem]" data-id="element-139" data-mp="1wvew0u7gh7ih">
                {PRICE}
              </p>

              <p className="mx-auto mt-4 max-w-[30ch] text-sm font-black leading-snug text-ink/55 sm:max-w-none sm:text-base" data-id="element-140" data-mp="1sxhaq2gt35kd">
                Pagamento unico · nessun abbonamento · accesso digitale
                immediato
              </p>

              <CtaButton tone="moss" showIcon={false} className="mt-6 w-full whitespace-nowrap" data-id="element-141" data-mp="1qhj5z6ar75l9">
                Acquista ora
              </CtaButton>

              <p className="mx-auto mt-4 max-w-[32ch] text-xs font-black leading-snug text-ink/50 sm:max-w-none sm:text-sm" data-id="element-142" data-mp="1vhdtr0z8ff23">
                Pagamento sicuro · accesso immediato · garanzia di 7 giorni
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}